<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<!--table head-->
			<v-divider class="mt-4" color="black" />
			<v-row class="subtitle-2 mx-4" no-gutters>
				<v-col v-for="(item, i) in headers" :key="i" :class="item.style"
					class="text-pre-wrap">
					{{ `${item.title}` | localize }}
				</v-col>
			</v-row>
			<v-divider color="black" />
			<!-- production sales tab -->
			<div v-if="products?.length > 0">
				<v-expansion-panels multiple v-model="tab">
					<v-expansion-panel v-for="item in modelsByTrademark" :key="item.trademarkId">
						<v-expansion-panel-header class="secondary--text" color="#E8EAF6">
							<!-- trademark-->
							{{'trademark' | localize }}: {{ item.trademark }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">
							<!--- models -->
							<div v-for="product in item.models" :key="product.id">
								<v-row no-gutters>
									<v-col class="text-left">{{ product.model }}</v-col>
									<v-col class="text-center">{{ status(product) }}</v-col>
									<v-col class="text-center">{{ product.material }}</v-col>
									<v-col class="text-center">{{ product.manufacturing }}</v-col>
									<v-col class="text-center">{{ `${product.design_type}` | localize }}</v-col>
									<v-col class="text-center">{{ product.design }}</v-col>
									<v-col class="text-center">{{ product.variations }}</v-col>
									
									<v-col v-if="product.advanced_feature" class="text-justify">
										{{ `${product.advanced_feature}` | localize }}
									</v-col>
									<v-col v-else class="text-center">-</v-col>

									<v-col v-show="product.sales_plan == 0" class="text-center error--text">
										{{ product.sales_plan }}
									</v-col>
									<v-col v-show="product.sales_plan !== 0" class="text-center secondary--text">{{
										localeNumber(product.sales_plan) }}</v-col>

									<v-col v-show="product.production_plan == 0" class="text-center error--text">{{
										product.production_plan }}
									</v-col>
									<v-col v-show="product.production_plan !== 0" class="text-center secondary--text">
										{{ localeNumber(product.production_plan) }}
									</v-col>

									<v-col class="text-center">{{ round(product.unit_cost) }}</v-col>

									<v-col v-show="product.retail_price == 0" class="text-center error--text">
										{{ product.retail_price }}
									</v-col>
									<v-col v-show="product.retail_price !== 0" class="text-center secondary--text">{{ product.retail_price }}</v-col>

									<v-col v-show="product.price == 0" class="text-center error--text">
										{{ product.price }}
									</v-col>
									<v-col v-show="product.price !== 0" class="text-center secondary--text">{{ product.price }}</v-col>

									<v-col class="text-center">{{ localeNumber(product.inventories_beginning) }}</v-col>
									<v-col class="text-right">
										<edit-product :product="product" />
									</v-col>
								</v-row>
								<v-divider />
							</div>
							<v-row class="subtitle-2 text-left mt-4" no-gutters>
								{{'Total production plan' | localize }}: {{ localeNumber(totalProductionPlan(item)) }} {{'units' | localize}}
							</v-row>
							<v-row class="subtitle-2 text-left" no-gutters>
								{{'Estimated sales value' | localize }}: $ {{ localeNumber(salesValue(item)) }}
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>
	</v-container>
</template>
<script>
import localizeFilter from '../../../filters/localize.filter.js';
import { getMonth, roundNumber } from '../../../functions/common';
import Loader from '../../../layouts/Loader.vue';

	export default {
		data () {
			return {
				tab: [0],
				isLoaded: false,
				headers: [
					{ title: 'Product', style: 'text-left'},
					{ title: 'Available', style: 'text-center'},
					{ title: 'Material', style: 'text-center' },
					{ title: 'Manufacturing', style: 'text-center'},
					{ title: 'Design type', style: 'text-center'},
					{ title: 'Design level', style: 'text-center' },
					{ title: 'Model variations', style: 'text-center'},
					{ title: 'Functional expansion', style: 'text-center'},
					{ title: 'Sales plan (units)', style: 'text-center'},
					{ title: 'Production plan (units)', style: 'text-center'},
					{ title: 'Unit cost $', style: 'text-center'},
					{ title: 'Retail price $', style: 'text-center'},
					{ title: 'Ex-works price $', style: 'text-center'},
					{ title: 'Inventories (units)', style: 'text-center'},
					{ title: 'Actions', style: 'text-right'},
				]
			}
		},
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			team() {
				return this.$store.getters.team;
			},
			game() {
				return this.$store.getters.game;
			},
			products() {
				return this.$store.getters.products;
			},
			modelsByTrademark() {
				const trademarks = [];
				if (this.products?.length > 0) {
					trademarks.push(
						{
							trademarkId: this.products[0].trademarkId,
							trademark: this.products[0].trademark.name,
							models: [this.products[0]]
						}
					)
					for (let i = 1; i < this.products.length; i++) {
						const inArr = trademarks.find(tr => tr.trademarkId === this.products[i].trademarkId)
						if (inArr) {
							inArr.models.push(this.products[i]);
						}
						else {
							trademarks.push(
								{
									trademarkId: this.products[i].trademarkId,
									trademark: this.products[i].trademark.name,
									models: [this.products[i]]
								}
							)
						}
					}
				}
				return trademarks;
			},
			sales() {
				return this.$store.getters.sales_team;
			},
		},
		methods: {
			localeNumber(num) {
				if (this.locale == 'ro-RO') {
					return num.toLocaleString('en-US')
				}
				return num.toLocaleString(this.locale)
			},
			round(num1) {
				return roundNumber(num1, 1);
			},
			status(product) {
				if (product.available_till < 12)
					return localizeFilter(`available till`) + ` ${getMonth(product.available_till)}`
				else if (product.available_from > 1)
					return `available from ${getMonth(product.available_from)}`
				else return localizeFilter('available')
			}, 
			totalProductionPlan(brand) {
				const res = brand.models.reduce((summ, model) => {
					return summ + model.production_plan;
				}, 0)
				return res
			},
			salesValue(brand) {
				const res = brand.models.reduce((summ, model) => {
					return summ + (model.sales_plan * model.retail_price)
				}, 0)

				return res.toLocaleString('en-US')
			},
			inventoriesBeginning(product) {
				let res = 0;
				if (this.sales?.length > 0) {
					const matched = this.sales.find((it) => it.productId == product.productId);
					if (matched) {
						res = matched.inventories_beginning;
					}
				}
				return res;
			},
			inventoriesEnd(product) {
			let res = 0;
			if (this.sales?.length > 0) {
				const matched = this.sales.find((it) => it.productId == product.productId);
				if (matched) {
					res = matched.inventories_end;
				}
			}
			return res;
		},

		},
		components: {
			EditProduct: () => import('../../../components/team/products/upgradeSales.vue'),
			Loader
		},
		async created() {		
			if (this.game && this.team) {

				const params = {
					gameId: this.game.id,
					round: this.game.round,
					teamId: this.team.id,
				}
				if (this.products == null) {
					try {
						await this.$store.dispatch('fetchTeamProducts', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message)	
					}
				}
							
				if (this.game.round > 0 && this.sales == null) {
					const params_last = {
						gameId: params.gameId,
						round: params.round - 1,
						teamId: params.teamId,
					}
					/*console.log(params_last) */
					try {
						await this.$store.dispatch('fetchTeamSales', params_last);
					} catch (error) {
						await this.$store.dispatch('setError', error.message)
					}
				}

				this.isLoaded = true;
			}
		}
	}
</script>
